<template>
  <v-card class="progress-status border">


    <v-row class="px-5 py-7">
      <v-col cols="6">
        <!-- PERCEIVED STRESS -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $t("stress.perceivedStress") }}</h3>
            <p v-if="showPerceivedStress" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ perceivedStressReportDate }}</p>
          </div>

          <v-row v-if="showPerceivedStress" align="center">
            <v-col cols="1">
              <smart-icon :icon="perceivedStressIcon" />
            </v-col>
            <v-col cols="11">{{ perceivedStressMessage }}</v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>

        <!-- STRESSORS -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $t("stress.stressors") }}</h3>
            <p v-if="showStressors" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ stressorsReportDate }}</p>
          </div>

          <v-row v-if="showStressors" align="center">
            <v-col cols="12">
              <ul>
                <li v-for="a in stressorsAnswers" v-bind:key="a.key">
                  <span v-if="a.key === 'OTHER'">{{ a.text }}: {{ stressorsOtherAnswer }}</span>
                  <span v-else>{{ a.text }}</span>
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>

        <!-- STRESS RELIEF TECHNIQUES -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $t("stress.stressReliefTechniques") }}</h3>
            <p v-if="showTechniques" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ techniquesReportDate }}</p>
          </div>

          <v-row v-if="showTechniques" align="center">
            <v-col cols="12">
              <ul>
                <li v-for="a in techniquesAnswers" v-bind:key="a.key">
                  <span v-if="a.key === 'OTHER'">{{ a.text }}: {{ techniquesOtherAnswer }}</span>
                  <span v-else>{{ a.text }}</span>
                </li>
              </ul>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>

        <!-- DEPRESSION -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $t("stress.depression.label") }}</h3>
            <p v-if="showDepression" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ PHQ9ReportDate }}</p>
          </div>

          <v-row v-if="showDepression" align="center">
            <v-col cols="12">
              <div>
                <span>
                  {{ $t("general.score", "app_mobile") }}: {{ PHQ9Score }}
                </span>
                  <span class="ml-10" :style="{color : PHQ9Message.color}">
                  {{ PHQ9Message.message }}
                </span>
              </div>
              <div>
                <ul>
                  <li v-for="a in PHQ9Choices" v-bind:key="a">
                    <span>{{ a }}</span>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>

        <!-- ANXIETY -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $ucfirst($t("educationOverview.function.keyword.anxietySearch", "content")) }}</h3>
            <p v-if="showAnxiety" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ GAD7ReportDate }}</p>
          </div>

          <v-row v-if="showAnxiety" align="center">
            <v-col cols="12">
              <div>
                <span>
                  {{ $t("general.score", "app_mobile") }}: {{ GAD7Score }}
                </span>
                <span class="ml-10" :style="{color : GAD7Message.color}">
                  {{ GAD7Message.message }}
                </span>
              </div>
              <div>
                <ul>
                  <li v-for="a in GAD7Choices" v-bind:key="a">
                    <span>{{ a }}</span>
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="6">
        <!-- COPING -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $t("stress.copingTitle") }}</h3>
            <p v-if="showCopingMeasurements" class="physical-activity-progress-status__reported-on pull-right">{{ $ucfirst($t("pa.reportedOn")) }} {{ copingMeasurementsReportDate }}</p>
          </div>

          <v-row v-if="showCopingMeasurements" align="center">
            <v-col cols="1">
              <smart-icon :icon="copingMeasurementsIcon" />
            </v-col>
            <v-col cols="11">{{ copingMeasurementsMessage }}</v-col>
          </v-row>
          <v-row v-else align="center">
            <v-col>
              {{ $t("noData") }}
            </v-col>
          </v-row>
        </div>

        <!-- STRESS RELIEF OVER TIME -->
        <div class="border pa-3 mb-6">
          <div class="clearfix">
            <h3 class="pb-5 pull-left">{{ $t("dummy.journeyProgress.overTime", {params  : {behaviourComponent : $t('behaviourComponentJourney.STRESSMANAGEMENT').toLowerCase()} }) }}</h3>
            <div class="pull-right">
              <v-row>
                <v-col cols="6" class="pt-0">
                  <span class="patient-overview-hn-progress-over-time--label">
                    {{ $ucfirst($t("general.from", {catalog: 'app_mobile'})) }}:
                  </span>
                    <date-picker
                        v-model="chosenStartDate"
                        class="patient-overview-hn-progress-over-time--picker"
                        :disabledDateMessage="$ucfirst($t('validation.invalidDate.dateFromEnrolment'))"
                        :datePickerAttr="{
                          min: minAllowedStartDateString,
                          max: maxAllowedStartDateString
                        }"
                    />
                </v-col>
                <v-col cols="6" class="pt-0">
                  <span class="patient-overview-hn-progress-over-time--label">
                    {{ $ucfirst($t("general.until", {catalog: 'app_mobile'})) }}:
                  </span>
                    <date-picker
                        v-model="chosenEndDate"
                        :disabledDateMessage="$ucfirst($t('validation.invalidDate.dateFromEnrolment'))"
                        :datePickerAttr="{
                          min: minAllowedStartDateString,
                          max: maxAllowedStartDateString
                        }"
                    />
                </v-col>
              </v-row>
            </div>
          </div>

          <div class="chart-container chart-container--stress-level">
            <h4>{{ $t("journeyOverTime.STRESS_LEVEL") }}</h4>
            <apexchart
                type="line"
                height="390"
                :options="stressLevelOverTimeChartSeriesOptions"
                :series="stressLevelOverTimeChartSeries"
            ></apexchart>
          </div>

<!--          <h3 class="pb-5 pull-left">{{ $t("behaviourComponentJourney.COPINGMEASUREMENTS") }}</h3>-->

          <div class="chart-container chart-container--coping-measurements">
            <h4>{{ $t("behaviourComponentJourney.COPINGMEASUREMENTS") }}</h4>
            <apexchart
                type="line"
                height="390"
                :options="copingOverTimeChartSeriesOptions"
                :series="copingOverTimeChartSeries"
            ></apexchart>
          </div>
        </div>
      </v-col>
    </v-row>


  </v-card>
</template>

<script>

import SmartIcon from "../../../components/Parts/SmartIcon.vue";
import {mapGetters} from "vuex";
import moment from "moment/moment";
import { getEntryWithQuestionKey } from "../../../../../helper/questionnaires";
import DatePicker from "../../../components/Parts/DatePicker";

function fillWithEmptiesFromOtherSeries(seriesToFill, otherSeries) {
  const returnSeries = Array.from(seriesToFill);

  for (let i=0; i<otherSeries.length; i++) {
    const otherEntry = otherSeries[i];
    let inOther = false;

    for (let j=0; j<returnSeries.length; j++) {
      const seriesEntry = returnSeries[j];
      if (otherEntry.date === seriesEntry.date) {
        inOther = true;
        break;
      }
    }

    if (!inOther) {
      returnSeries.push({score : null, date : otherEntry.date, key : null})
    }
  }

  return returnSeries;
}

export default {
  name: "PatientOverviewStressProgress",
  components: {SmartIcon, DatePicker},
  data: function() {
    return {
      numberOfDaysWithActivityIconName: 'mdi-emoticon-excited-outline',
      perceivedStressForm : null,
      copingMeasurementsForm: null,
      stressorsForm: null,
      techniquesForm: null,
      PHQ9Form : null,
      GAD7Form : null,
      chosenStartDate: this.$store.getters["patientSummary/lastCompletedSDMEncounterDate"],
      chosenEndDate: moment(),
      perceivedStressOverTimeForms: null,
      copingMeasurementsOverTimeForms: null,
    }
  },
  mounted: function() {
    this.loadData();
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    showPerceivedStress () {
      return !!this.perceivedStressForm;
    },
    perceivedStressScore() {
      return this.perceivedStressForm !== null ? parseInt(this.perceivedStressForm.score) : null;
    },
    perceivedStressMessage() {
      if (this.perceivedStressForm) {
        return this.$t('stress.stressedSentence',   {
          params: { patientReportedValue: this.perceivedStressForm.entries[0].givenAnswers[0].text.toLowerCase() },
          startingParamTransform : (param) => this.$ucfirst(param)
        })
      }

      return '';
    },
    perceivedStressIcon() {
      if (this.perceivedStressScore === null) {
        return '';
      }

      switch (this.perceivedStressScore) {
        case 5:
          return 'icon-smiley1';
        case 4:
          return 'icon-smiley2';
        case 3:
          return 'icon-smiley3';
        case 2:
          return 'icon-smiley4';
        default:
          return 'icon-smiley5';
      }
    },
    perceivedStressReportDate() {
      return this.perceivedStressForm ? moment(this.perceivedStressForm.entryDate).format('DD/MM/YYYY') : null;
    },
    showCopingMeasurements () {
      return this.perceivedStressForm && this.copingMeasurementsForm && this.perceivedStressForm?.entries[0].givenAnswers[0].key !== 'NOT_AT_ALL';
    },
    copingMeasurementsScore() {
      if (!this.showCopingMeasurements) {
        return null;
      }

      return this.copingMeasurementsForm !== null ? parseInt(this.copingMeasurementsForm.score) : null;
    },
    copingMeasurementsMessage() {
      if (!this.showCopingMeasurements) {
        return '';
      }

      if (this.perceivedStressForm) {
        return this.$t('stress.copingSentence',   {
          params: { patientReportedValue: this.copingMeasurementsForm.entries[0].givenAnswers[0].text.toLowerCase() } ,
          startingParamTransform : (param) => this.$ucfirst(param)
        })
      }

      return '';
    },
    copingMeasurementsIcon() {
      if (this.copingMeasurementsScore === null) {
        return '';
      }

      switch (this.copingMeasurementsScore) {
        case 5:
          return 'icon-smiley5';
        case 4:
          return 'icon-smiley4';
        case 3:
          return 'icon-smiley3';
        case 2:
          return 'icon-smiley2';
        default:
          return 'icon-smiley1';
      }
    },
    copingMeasurementsReportDate() {
      return this.copingMeasurementsForm ? moment(this.copingMeasurementsForm.entryDate).format('DD/MM/YYYY') : null;
    },
    showStressors () {
      return this.perceivedStressForm && this.stressorsForm && this.perceivedStressForm?.entries[0].givenAnswers[0].key !== 'NOT_AT_ALL';
    },
    stressorsReportDate() {
      return this.stressorsForm ? moment(this.stressorsForm.entryDate).format('DD/MM/YYYY') : null;
    },
    stressorsAnswers () {
      if (this.stressorsForm) {
        return getEntryWithQuestionKey(this.stressorsForm, 'DIFFICULTIES_UPSET').givenAnswers;
      }

      return [];
    },
    stressorsOtherAnswer () {
      if (this.stressorsForm) {
        return getEntryWithQuestionKey(this.stressorsForm, 'OTHER').givenAnswers[0].openAnswer;
      }

      return '';
    },
    showTechniques () {
      return this.perceivedStressForm && this.techniquesForm && this.perceivedStressForm?.entries[0].givenAnswers[0].key !== 'NOT_AT_ALL';
    },
    techniquesReportDate() {
      return this.techniquesForm ? moment(this.techniquesForm.entryDate).format('DD/MM/YYYY') : null;
    },
    techniquesAnswers () {
      if (this.techniquesForm) {
        return getEntryWithQuestionKey(this.techniquesForm, 'HELPS_REDUCES_STRESS').givenAnswers;
      }

      return [];
    },
    techniquesOtherAnswer () {
      if (this.techniquesForm) {
        return getEntryWithQuestionKey(this.techniquesForm, 'OTHER').givenAnswers[0].openAnswer;
      }

      return '';
    },
    showDepression () {
      return !!this.PHQ9Form;
    },
    PHQ9ReportDate() {
      return this.PHQ9Form ? moment(this.PHQ9Form.entryDate).format('DD/MM/YYYY') : null;
    },
    PHQ9Score() {
      return this.PHQ9Form !== null ? parseInt(this.PHQ9Form.score) : null;
    },
    PHQ9Message() {
      const score = this.PHQ9Score;

      if (score >= 20) {
        return { message : this.$t('stress.depression.severeDepressionScore'), color : this.$color.coro['status-red']}
      }else if (score >= 15) {
        return { message : this.$t('stress.depression.moderatelySevereDepressionScore'), color : this.$color.coro['status-red']}
      }else if (score >= 10) {
        return { message : this.$t('stress.depression.moderateDepressionScore'), color : this.$color.coro['status-red']}
      }else if (score >= 5) {
        return { message : this.$t('stress.depression.mildDepressionScore'), color : this.$color.coro['status-orange']}
      }else if (score >= 1) {
        return { message : this.$t('stress.depression.minimalDepressionScore'), color : this.$color.coro['status-green']}
      }

      return { message : '', color : this.$color.coro['status-green'] };
    },
    PHQ9Choices() {
      if (this.PHQ9Form) {
        const result = [];

        for (let i=0; i<this.PHQ9Form.entries.length; i++) {
          const entry = this.PHQ9Form.entries[i];

          if (entry.givenAnswers[0] && entry.question.key !== 'COPING' && entry.givenAnswers[0].key !== 'NOT_AT_ALL') {
            // Remove number prefix from the choice
            result.push(entry.question.text .replace(/^\d+\.\s*/, ''));
          }
        }

        return result;
      }

      return [];
    },
    showAnxiety() {
      return !!this.GAD7Form;
    },
    GAD7ReportDate() {
      return this.GAD7Form ? moment(this.GAD7Form.entryDate).format('DD/MM/YYYY') : null;
    },
    GAD7Score() {
      return this.GAD7Form !== null ? parseInt(this.GAD7Form.score) : null;
    },
    GAD7Message() {
      const score = this.GAD7Score;

      if (score >= 15) {
        return { message : this.$t('stress.anxiety.severeAnxietyScore'), color : this.$color.coro['status-red']}
      }else if (score >= 10) {
        return { message : this.$t('stress.anxiety.moderateAnxietyScore'), color : this.$color.coro['status-red']}
      }else if (score >= 5) {
        return { message : this.$t('stress.anxiety.mildAnxietyScore'), color : this.$color.coro['status-orange']}
      }else if (score >= 1) {
        return { message : this.$t('stress.anxiety.minimalAnxietyScore'), color : this.$color.coro['status-green']}
      }

      return { message : '', color : this.$color.coro['status-green'] };
    },
    GAD7Choices() {
      if (this.GAD7Form) {
        const result = [];

        for (let i=0; i<this.GAD7Form.entries.length; i++) {
          const entry = this.GAD7Form.entries[i];

          if (entry.givenAnswers[0] && entry.question.key !== 'COPING' && entry.givenAnswers[0].key !== 'NOT_AT_ALL') {
            // Remove number prefix from the choice
            result.push(entry.question.text .replace(/^\d+\.\s*/, ''));
          }
        }

        return result;
      }

      return [];
    },
    minAllowedStartDate() {
      let lastVisitDate = this.$store.getters["patientSummary/visit1Date"];
      return moment(lastVisitDate);
    },
    minAllowedStartDateString() {
      return this.minAllowedStartDate ? this.minAllowedStartDate.format('YYYY-MM-DD') : null
    },
    maxAllowedStartDate() {
      return moment();
    },
    maxAllowedStartDateString() {
      return this.maxAllowedStartDate ? this.maxAllowedStartDate.format('YYYY-MM-DD') : null
    },
    stressLevelOverTimeDataNoAutofill() {
      return this.perceivedStressOverTimeForms ? this.perceivedStressOverTimeForms.map((form) => {
        return {score : parseInt(form.score), date : form.entryDate, key : form.entries[0].givenAnswers[0].key };
      }) : [];
    },
    stressLevelOverTimeData() {
      // Include an empty value at the same dates for the other series entries, so both series have the same x-axis limits/intervals.
      return fillWithEmptiesFromOtherSeries(this.stressLevelOverTimeDataNoAutofill, this.copingOverTimeDataNoAutofill);
    },
    stressLevelOverTimeChartSeries() {
      return [
        {
          data : this.stressLevelOverTimeData.map(entry => {
            const date = moment.tz(entry.date, 'YYYY-MM-DD HH:mm:ss', 'UTC').startOf('day').utc();

            return {
              x : date,
              y : entry.score
            }
          }),
          name : this.$t("dummy.journeyProgress.overTime", {params  : {behaviourComponent : this.$t('behaviourComponentJourney.STRESSMANAGEMENT').toLowerCase()} })
        },
      ];
    },
    stressLevelOverTimeChartSeriesOptions() {
      return {
        chart: {
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        colors: ['#008ffb'],
        grid: {
          padding: {
            left: 80,
          },
        },
        xaxis: {
          type: "datetime",
          title: {
            text: this.$ucfirst(this.$t("alerts.time")),
            style: {
              fontSize: '0.75rem',
            },
          },
          tickAmount: 1,
          labels: {
            formatter: (val) => {
              return moment(val).format('DD/MM/YY')
            },
            rotate: -20,
            minHeight: 90,
            offsetY: 8,
            rotateAlways: true,
            hideOverlappingLabels: true,
            style: {
              fontSize: '0.75rem',
            }
          },
          min: moment.parseZone(this.chosenStartDate.format('YYYY-MM-DD HH:mm:ss')).valueOf(),
          max: moment.parseZone(this.chosenEndDate.format('YYYY-MM-DD HH:mm:ss')).valueOf(),
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return this.getLabelForScorePerceivedStress(val);
            },
            style: {
              fontSize: '0.75rem',
            },
            offsetX: 50,
          },
          min: 1,
          max: 5,
          tickAmount: 4,
        },
        legend: {
          show: false
        },
        markers: {
          size: 4,
          strokeWidth: 1,
          hover: {
            size: 6,
          }
        },
      };
    },
    copingOverTimeDataNoAutofill() {
      return this.copingMeasurementsOverTimeForms ? this.copingMeasurementsOverTimeForms.map((form) => {
        return {score : parseInt(form.score), date : form.entryDate, key : form.entries[0].givenAnswers[0].key };
      }) : [];
    },
    copingOverTimeData() {
      // Include an empty value at the same dates for the other series entries, so both series have the same x-axis limits/intervals.
      return fillWithEmptiesFromOtherSeries(this.copingOverTimeDataNoAutofill, this.stressLevelOverTimeDataNoAutofill);
    },
    copingOverTimeChartSeries() {
      return [
        {
          data : this.copingOverTimeData.map(entry => {
            const date = moment.tz(entry.date, 'YYYY-MM-DD HH:mm:ss', 'UTC').startOf('day').utc();

            return {
              x : date,
              y : entry.score
            }
          }),
          name : this.$t("behaviourComponentJourney.COPINGMEASUREMENTS" )
        },
      ];
    },
    copingOverTimeChartSeriesOptions() {
      return {
        chart: {
          type: "line",
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        colors: ['#008ffb'],
        grid: {
          padding: {
            left: 80,
          },
        },
        xaxis: {
          type: "datetime",
          title: {
            text: this.$ucfirst(this.$t("alerts.time")),
            style: {
              fontSize: '0.75rem',
            },
          },
          tickAmount: 1,
          labels: {
            formatter: (val) => {
              return moment(val).format('DD/MM/YY')
            },
            rotate: -20,
            minHeight: 90,
            offsetY: 8,
            rotateAlways: true,
            hideOverlappingLabels: true,
            style: {
              fontSize: '0.75rem',
            },
          },
          min: moment.parseZone(this.chosenStartDate.format('YYYY-MM-DD HH:mm:ss')).valueOf(),
          max: moment.parseZone(this.chosenEndDate.format('YYYY-MM-DD HH:mm:ss')).valueOf(),
        },
        yaxis: {
          labels: {
            formatter: (val) => {
              return this.getLabelForScoreCopingMeasurements(val);
            },
            style: {
              fontSize: '0.75rem',
            },
            offsetX: 50,
          },
          min: 1,
          max: 5,
          tickAmount: 4,
        },
        legend: {
          show: false
        },
        markers: {
          size: 4,
          strokeWidth: 1,
          hover: {
            size: 6,
          }
        },
      };
    },
  },
  methods : {
    loadData() {
      this.getPerceivedStressForm();
      this.getCopingMeasurementsForm();
      this.getStressorsForm();
      this.getTechniquesForm();
      this.getPHQ9Form();
      this.getGAD7Form();
      this.loadChartOverTimeData();
    },
    loadChartOverTimeData() {
      this.getPerceivedStressOverTimeForms();
      this.getCopingMeasurementsOverTimeForms();
    },
    async getPerceivedStressForm() {
      this.perceivedStressForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'PERCEIVEDSTRESS')
    },
    async getCopingMeasurementsForm() {
      this.copingMeasurementsForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'COPINGMEASUREMENTS')
    },
    async getStressorsForm() {
      this.stressorsForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'MYSTRESSORS')
    },
    async getTechniquesForm() {
      this.techniquesForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'STRESSRELIEFTECHNIQUES')
    },
    async getPHQ9Form() {
      this.PHQ9Form = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'PHQ-9')
    },
    async getGAD7Form() {
      this.GAD7Form = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'GAD-7')
    },
    async getPerceivedStressOverTimeForms() {
      this.perceivedStressOverTimeForms = await this.$app.questionnaireManager.getPatientQuestionnaires(
          this.patientId,
          null,
          'PERCEIVEDSTRESS',
          this.chosenStartDate,
          this.chosenEndDate.clone().add(1, 'days'),
          null,
          false,
          true
      )
    },
    async getCopingMeasurementsOverTimeForms() {
      this.copingMeasurementsOverTimeForms = await this.$app.questionnaireManager.getPatientQuestionnaires(
          this.patientId,
          null,
          'COPINGMEASUREMENTS',
          this.chosenStartDate,
          this.chosenEndDate.clone().add(1, 'days'),
          null,
          false,
          true
      )
    },
    getLabelForScorePerceivedStress(score) {
      switch (score) {
        case 1:
          return this.$t('questionnaires.MY_MOTIVATION.questions.A_NOT_AT_ALL', 'questionnaires');
        case 2:
          return this.$t('questionnaires.MY_MOTIVATION.questions.A_ONLY_A_LITTLE', 'questionnaires');
        case 3:
          return this.$t('questionnaires.MY_MOTIVATION.questions.A_TO_SOME_EXTEND', 'questionnaires');
        case 4:
          return this.$t('questionnaires.MY_MOTIVATION.questions.A_RATHER_MUCH', 'questionnaires');
        case 5:
          return this.$t('questionnaires.MY_MOTIVATION.questions.A_VERY_MUCH', 'questionnaires');
      }

      return '';
    },
    getLabelForScoreCopingMeasurements(score) {
      switch (score) {
        case 1:
          return this.$t('medicationAdherenceProgress.never',);
        case 2:
          return this.$t('medicationAdherenceProgress.rarely',);
        case 3:
          return this.$t('medicationAdherenceProgress.sometimes',);
        case 4:
          return this.$t('medicationAdherenceProgress.often',);
        case 5:
          return this.$t('medicationAdherenceProgress.always',);
      }

      return '';
    }
  },
  watch: {
    patientId: function () {
      this.loadData();
    },
    chosenStartDate() {
      if (this.chosenStartDate && this.chosenEndDate && this.chosenEndDate.isBefore(this.chosenStartDate)) {
        this.chosenEndDate = this.chosenStartDate.clone();
      }

      this.loadChartOverTimeData();
    },
    chosenEndDate() {
      if (this.chosenStartDate && this.chosenEndDate && this.chosenStartDate.isAfter(this.chosenEndDate)) {
        this.chosenStartDate = this.chosenEndDate.clone();
      }

      this.loadChartOverTimeData();
    },
  },
};
</script>

<style scoped lang="scss">
.physical-activity-progress-status__reported-on {
  text-align: right;
}
.chart-container {
  padding-left: 50px;
  position: relative;

  >h4 {
    position: absolute;
    transform: translateX(-230px) translateY(146px) rotate(270deg);
    width: 400px;
    text-align: center;
    pointer-events: none;
  }

  &.chart-container--coping-measurements{
    >h4{
      top: 40px;
    }
  }
}
</style>
